import type { BranchMinimumCartSystemValueType } from '../enums/BranchMinimumCartSystemValueType'
import type { SegmentEntity } from './SegmentEntity'

export class BranchMinimumCartSystemEntity {
  id?: number
  name?: string | null
  isDefault?: boolean
  valueType?: BranchMinimumCartSystemValueType
  perDirectDistance?: {
    amountPerKm?: number
  }
  perDirectDistanceSegment?: {
    segments?: SegmentEntity[]
  }
}
